import React, { Fragment, useEffect, useState } from "react";

import DropdownMultiselect from "react-multiselect-dropdown-bootstrap";
import {
    Row,
    Col,
    Card,
    Table,
    Badge,
    Dropdown,
    ProgressBar,
} from "react-bootstrap";
import { verifyFormData } from "./VerifyForm";
import { FaUserLarge } from "react-icons/fa6";

import RemarkModal from "./RemarkModal";


import { getInsituteverifyByID } from "../../../services/adminApiService/insituteVerficationApi/InsituteVerficationApiService";
import { useParams } from "react-router-dom";
import InsituteVerficationMapping from "../../../utils/maping/InsituteVerficationMapping";
import NotCleardCard from "./NotCleardCard";
import CleardCard from "./CleardCard";
import { getIndividualVerfiedByID } from "../../../services/adminApiService/individualApiService/IndividualAPiService";
import ViewProject from '../../../jsx/pages/WidgetBasic/ViewProject';
import { formatLable, formatStatus, getStatusColor } from "../../../utils/colorAsperStatus";
import IndividualDetails from "./IndividualDetails";


const IndividualVerificationForm = () => {
    const { id } = useParams();
    const [remarkshowModal, setRemarkshowModal] = useState(false);
    const [showremarkrCard, setshowremarkCard] = useState(true);
    const [verficationList, setVerficationList] = useState({});
    const [insituteVerifyList, setInsituteVerifyList] = useState([]);
   



    const [remarkdata, setRemarkdata] = useState('');
    const [currentRemarkId, setCurrentRemarkId] = useState(null);


    useEffect(() => {
        const fetchVerificationList = async () => {
            try {
                const response = await getIndividualVerfiedByID(id);
                setVerficationList(response?.data?.data);
            } catch (error) {
                console.error('Error fetching verification list:', error);
            }
        };

        fetchVerificationList();
    }, [id]);
    const isValidUrl = (string) => {
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    };

    useEffect(() => {
        const storedRemarks = JSON.parse(localStorage.getItem(`remarksIndividual-${id}`)) || {};

        if (Object.keys(verficationList).length > 0) {
            const baseList = [
                { id: 1, label: "Name", value: verficationList?.first_name, key: "first_name", action: false, remark: storedRemarks[1] || "" },
                { id: 2, label: "Date of Birth", value: verficationList?.dob, key: "dob", action: false, remark: storedRemarks[2] || "" },
                { id: 3, label: "Age", value: verficationList?.age, key: "age", action: false, remark: storedRemarks[3] || "" },
                { id: 4, label: "Gender", value: verficationList?.gender, key: "gender", action: false, remark: storedRemarks[4] || "" },
                { id: 5, label: "Mobile", value: verficationList?.mobile, key: "mobile", action: false, remark: storedRemarks[5] || "" },
                { id: 6, label: "Email", value: verficationList?.email, key: "email", action: false, remark: storedRemarks[6] || "" },
                { id: 7, label: "Address", value: verficationList?.address, key: "address", action: false, remark: storedRemarks[7] || "" },
                { id: 8, label: "Landmark", value: verficationList?.landmark, key: "landmark", action: false, remark: storedRemarks[8] || "" },
                { id: 9, label: "Country", value: verficationList?.country, key: "country", action: false, remark: storedRemarks[9] || "" },
                { id: 10, label: "State", value: verficationList?.state, key: "state", action: false, remark: storedRemarks[10] || "" },
                { id: 11, label: "City", value: verficationList?.city, key: "city", action: false, remark: storedRemarks[11] || "" },
                { id: 12, label: "Sport id", value: verficationList?.sport_id, key: "sport_id", action: false, remark: storedRemarks[12] || "" },
                { id: 13, label: "kit size", value: verficationList?.kit_size, key: "kit_size", action: false, remark: storedRemarks[13] || "" },
                { id: 14, label: "Athlete Level", value: verficationList?.athlete_level, key: "athlete_level", action: false, remark: storedRemarks[14] || "" },
                { id: 15, label: "Account Holder Name", value: verficationList?.account_holder_name, key: "account_holder_name", action: false, remark: storedRemarks[18] || "" },
                { id: 16, label: "Bank Account Number", value: verficationList?.bank_account_number, key: "bank_account_number", action: false, remark: storedRemarks[19] || "" },
                { id: 17, label: "Ifsc code", value: verficationList?.ifsc_code, key: "ifsc_code", action: false, remark: storedRemarks[20] || "" },
                { id: 18, label: "Branch Name", value: verficationList?.branch_name, key: "branch_name", action: false, remark: storedRemarks[21] || "" },
                { id: 19, label: "Education Level", value: verficationList?.education_level, key: "education_level", action: false, remark: storedRemarks[15] || "" },
                { id: 20, label: "Marital Status", value: verficationList?.maritial_status, key: "maritial_status", action: false, remark: storedRemarks[15] || "" },
                { id: 21, label: "Highest Achivement", value: verficationList?.highest_achievement, key: "highest_achievement", action: false, remark: storedRemarks[15] || "" },
                { id: 22, label: "Identity Card", value: verficationList?.identity_card, key: "identity_card", action: false, remark: storedRemarks[15] || "" },
            ];

            if (verficationList.registration_docs && Array.isArray(verficationList.registration_docs)) {
                verficationList.registration_docs.forEach((doc, index) => {
                    console.log("doc===>",doc);
                    baseList.push({
                        id: 23 + index, // Assuming the IDs continue sequentially
                        label: doc.doc_name,
                        value: doc.doc_file, // Assuming you want to display the file or use doc_name
                        key: `registration_doc_${index + 1}`,
                        action: false,
                        remark: storedRemarks[23 + index] || ""
                    });
                });
            }
    
            setInsituteVerifyList(baseList);
        }
    
       
    }, [verficationList, id]);

    const handleRadioChange = (id) => {
        setCurrentRemarkId(id);
        setRemarkshowModal(true);
        setshowremarkCard(false);
    };



    const updateRemark = (remark) => {
        const updatedList = insituteVerifyList.map(item => {
            if (item.id === currentRemarkId) {
                return { ...item, remark };
            }
            return item;
        });

        setInsituteVerifyList(updatedList);

        const storedRemarks = JSON.parse(localStorage.getItem(`remarksIndividual-${id}`)) || {};
        storedRemarks[currentRemarkId] = remark;
        localStorage.setItem(`remarksIndividual-${id}`, JSON.stringify(storedRemarks));
    };







    return (
        <>
           <IndividualDetails verficationList={verficationList}/>
            <div className="row">
                <Col lg={12} className="mb-3">
                    <Card style={{ height: '35vh' }}>
                        <Card.Header>
                            <Card.Title className="text-danger">VERIFY PHOTO</Card.Title>
                        </Card.Header>
                        <Card.Body >
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Student Profile Photo</th>
                                        <th>Action</th>
                                        <th>Remarks</th>

                                    </tr>

                                </thead>
                                <tbody>
                                    <tr>
                                        <th>1</th>

                                        <td>
                                            {insituteVerifyList.length > 0 && insituteVerifyList[22]?.value ? (
                                                <img
                                                    src={insituteVerifyList[22].value}
                                                    alt="Profile"
                                                    style={{ width: '100px', height: '100px' }}
                                                />
                                            ) : (
                                                'Photo not available'
                                            )}
                                        </td>
                                        <td>
                                            <div className="d-flex">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input bg-success"
                                                        type="radio"
                                                        name="gridRadios"
                                                        value="option1"
                                                        defaultChecked
                                                    />



                                                </div>
                                                <div className="form-check mx-2">
                                                    <input
                                                        className="form-check-input bg-danger"
                                                        type="radio"
                                                        name="gridRadios"
                                                        value="option1"
                                                        checked={false}
                                                        onChange={(event) => handleRadioChange(event?.data?.id)}

                                                    />



                                                </div>
                                            </div>

                                        </td>
                                        <td></td>



                                    </tr>

                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>


                    <Card className="mb-3" style={{ height: 'auto' }}>
                        <Card.Header>
                            <Card.Title className="text-danger">VERIFY FORM FIELDS & DOCUMENTS</Card.Title>
                        </Card.Header>
                        <Card.Body >
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Form Fields</th>
                                        <th>Action</th>
                                        <th>Remarks</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {insituteVerifyList
                                        .filter(data => data.value)
                                        .map((data, index) => (
                                            <tr key={data.id}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    <span style={{ color: "#886CC0" }} ><strong>{formatLable(data?.label)}</strong></span><br />
                                                    {isValidUrl(data.value) ? (
                                                        <img src={data.value} alt={data.label} style={{ maxWidth: "100px", height: "auto" }} />
                                                    ) : (
                                                        <span style={{ fontSize: "13px" }}>{data.value}</span>
                                                    )}
                                                </td>
                                                <td>
                                                    <div className="d-flex">
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input bg-success"
                                                                type="radio"
                                                                name={`gridRadios-${data.id}`}
                                                                value="option1"
                                                                defaultChecked
                                                            />
                                                        </div>
                                                        <div className="form-check mx-2">
                                                            <input
                                                                className="form-check-input bg-danger"
                                                                type="radio"
                                                                name={`gridRadios-${data.id}`}
                                                                value="option1"
                                                                checked={false}
                                                                onChange={(event) => handleRadioChange(data?.id)}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    {data.remark}
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>




                </Col>

            </div>
            <RemarkModal remarkshowModal={remarkshowModal} setRemarkshowModal={setRemarkshowModal} setRemarkdata={setRemarkdata} setVerficationList={setVerficationList} remarkdata={remarkdata} currentRemarkId={currentRemarkId} updateRemark={updateRemark} />
           
           
            {
                (verficationList?.status === "final_submit" || verficationList?.status === "ask_for_resubmit") ? (
                    showremarkrCard ? (
                        <CleardCard id="1"/>
                    ) : (
                        <NotCleardCard insituteVerifyList={insituteVerifyList} id="1"/>
                    )
                ) : (verficationList?.status === "ongoing")? (
                    <Card className="text-center p-3"> 
                        <h3 className="text-danger">It seems that Institution has not started further registration Process!
</h3>
                    </Card>
                ):""
            }


        </>

    )
}

export default IndividualVerificationForm